import Plyr from 'plyr';
let jQuery = require('jquery');
let isTouch = jQuery('html').hasClass("touch-device");

var playerInited;

// document.addEventListener('hover', debounce(function(){
// console.log('hovering')
// }, 1000))
const debounce = function (func, delay) {
	let timer;
	return function () {
		//anonymous function
		const context = this;
		const args = arguments;
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};

document.addEventListener('DOMContentLoaded', () => {
  function videoItem(vidSrc, imgSrc, path, element, more) {
    let html = '<div class="video-container">';
    html += '<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg class="js-svg" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="32px" height="32px" viewBox="0 0 128 128" xml:space="preserve"><g><path d="M122.5 69.25H96.47a33.1 33.1 0 0 0 0-10.5h26.05a5.25 5.25 0 0 1 0 10.5z" fill="#000000" fill-opacity="1"/><path d="M112.04 97.83L89.47 84.8a33.1 33.1 0 0 0 5.25-9.1l22.57 13.03a5.25 5.25 0 0 1-5.28 9.1z" fill="#b2b2b2" fill-opacity="0.3"/><path d="M88.68 117.35L75.65 94.78a33.1 33.1 0 0 0 9.1-5.25l13.02 22.57a5.25 5.25 0 1 1-9.1 5.25z" fill="#b2b2b2" fill-opacity="0.3"/><path d="M58.7 122.57V96.5a33.1 33.1 0 0 0 10.5 0v26.07a5.25 5.25 0 0 1-10.5 0z" fill="#b2b2b2" fill-opacity="0.3"/><path d="M30.1 112.1l13.04-22.57a33.1 33.1 0 0 0 9.1 5.25L39.2 117.35a5.25 5.25 0 1 1-9.1-5.25z" fill="#b2b2b2" fill-opacity="0.3"/><path d="M10.6 88.74L33.16 75.7a33.1 33.1 0 0 0 5.25 9.1L15.88 97.83a5.25 5.25 0 1 1-5.25-9.1z" fill="#b2b2b2" fill-opacity="0.3"/><path d="M5.37 58.75h26.06a33.1 33.1 0 0 0 0 10.5H5.37a5.25 5.25 0 0 1 0-10.5z" fill="#999999" fill-opacity="0.4"/><path d="M15.85 30.17L38.4 43.2a33.1 33.1 0 0 0-5.24 9.1L10.6 39.25a5.25 5.25 0 1 1 5.25-9.1z" fill="#7f7f7f" fill-opacity="0.5"/><path d="M39.2 10.65l13.03 22.57a33.1 33.1 0 0 0-9.1 5.25l-13-22.57a5.25 5.25 0 1 1 9.1-5.25z" fill="#666666" fill-opacity="0.6"/><path d="M69.2 5.43V31.5a33.1 33.1 0 0 0-10.5 0V5.42a5.25 5.25 0 1 1 10.5 0z" fill="#4c4c4c" fill-opacity="0.7"/><path d="M97.77 15.9L84.75 38.47a33.1 33.1 0 0 0-9.1-5.25l13.03-22.57a5.25 5.25 0 1 1 9.1 5.25z" fill="#333333" fill-opacity="0.8"/><path d="M117.3 39.26L94.7 52.3a33.1 33.1 0 0 0-5.25-9.1l22.57-13.03a5.25 5.25 0 0 1 5.25 9.1z" fill="#191919" fill-opacity="0.9"/><animateTransform attributeName="transform" type="rotate" values="0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64" calcMode="discrete" dur="1080ms" repeatCount="indefinite"></animateTransform></g></svg>';
    html += '<video class="js-player" playsinline muted preload="none" data-poster="' + imgSrc + '">';
    html += '<source src="'+ vidSrc + '" type="video/mp4">';
    html += '</video>';
    html += '</div>';
    html += '<div class="preview-see-more"><a href="'+ path +'" class="button yellow-button yellow-button-more">'+ more +'</a></div>';

    if(!element.find('.video-container').length)
      element.append(html);
  }
  if (window.matchMedia("(pointer: coarse)").matches) {
    // console.log('Is Touch!!!')
    var getPointerEvent = function(event) {
      return event.originalEvent.targetTouches ? event.originalEvent.targetTouches[0] : event;
    };
    var $touchArea = jQuery('main'),
        mobPreview = jQuery('.mobile-video-preview .wrapper'),
        touchType = null,
        elemParent = null,
        pointer  = null,
        elem = null,
        previewElem = null,
        touchStarted = false, // detect if a touch event is sarted
        currX = 0,
        currY = 0,
        cachedX = 0,
        cachedY = 0;
//setting the events listeners
    $touchArea.on('touchstart mousedown',function (e){
      if (previewElem !== null) {
        //console.log('CLEAR PREVIEW');
        mobPreview.parent().removeClass('is-active');
        mobPreview.empty();
        previewElem = null;
      }
      elemParent = jQuery(e.target).parent();
      if (!jQuery(e.target).hasClass('yellow-button-more') && (elemParent.hasClass('scene') || elemParent.hasClass('movie')) && elemParent.data('src') !== null && elemParent.data('src').length > 0) {
        //console.log(elemParent.data('src'));
        e.stopPropagation();
        touchType = 'Tap';
        let pointer = getPointerEvent(e);
        // caching the current x
        cachedX = pointer.pageX;
        currX = pointer.pageX;
        // caching the current y
        cachedY = pointer.pageY;
        currY = pointer.pageY;
        // a touch event is detected
        touchStarted = true;
        //console.log('Touchstarted');
        //console.log(cachedX,cachedY);
        // detecting if after 200ms the finger is still in the same position
        setTimeout(function () {
          if ((cachedX === currX) && touchStarted && (cachedY === currY)) {
            // Here you get the Tap event
            //console.log('Tap & Hold');
            touchType = 'Hold';
            elem = jQuery(e.target);
            let leftPos = elem.offset().left + elem.outerWidth();
            let rightPos = elem.width() - (elem.offset().left + elem.outerWidth());
            previewElem = elemParent.find('.preview');
            let videoSrc = previewElem.data('vid');
            let imgSrc = previewElem.data('img');
            let path = previewElem.data('path');
            let more = previewElem.data('more');


            //elemParent.addClass('hovered');
            //console.log(elem, videoSrc, imgSrc, path, previewElem);
            videoItem(videoSrc, imgSrc, path, mobPreview, more);
            mobPreview.parent().addClass('is-active');

            let vidMobileload = setInterval(function () {
              // console.log('PLYRRRRR')
              if(jQuery('.js-player').length > 0){
                let player = new Plyr('.js-player', {
                  "controls": [
                    'progress'
                  ],
                  loop: {
                    active: true
                  },
                  volume: 0,
                  muted: true
                });
                if (player) {
                  // playerInited = player;
                  if(soundState){
                    player.muted = soundState;
                    player.volume = 0;
                  } else {
                    player.muted = soundState;
                    player.volume = 1;
                  }
                  player.play().catch(error => {
                      // Autoplay not allowed!
                      // Mute video and try to play again
                      player.play();
                      // Show something in the UI that the video is muted
                    });
                  //jQuery(this).prop('muted', false);
                }
                // if (player) {
                //   player.muted = true;
                //   player.volume = 0;
                //   player.play().catch(error => {
                //     // Autoplay not allowed!
                //     // Mute video and try to play again
                //     player.play();
                //     // Show something in the UI that the video is muted
                //   });
                // }
                  clearInterval(vidMobileload)
              }
            }, 100);
            //console.log(e.target);
            //console.log(elementMouseIsOver);
          }
        }, 250);
      }
    });
    $touchArea.on('touchend mouseup touchcancel',function (e){
      elemParent = jQuery(e.target).parent();
      if ((elemParent.hasClass('scene') || elemParent.hasClass('movie')) && elemParent.data('src') !== null && elemParent.data('src').length > 0) {
        //e.preventDefault();
        if (touchType !== null && touchType == 'Tap') {
          touchType = null;
          window.location.href = elemParent.data('path');
        }
        // here we can consider finished the touch event
        touchStarted = false;
        //console.log('Touchended');
      }
      if (previewElem !== null) {
        //console.log('CLEAR PREVIEW');
        mobPreview.parent().removeClass('is-active');
        mobPreview.empty();
        previewElem = null;
      }
    });
    $touchArea.on('touchmove mousemove',function (e){
      //elemParent = jQuery(e.target).parent();
      touchType = 'Swipe';
      let pointer = getPointerEvent(e);
      // caching the current x
      currX = pointer.pageX;
      // caching the current y
      currY = pointer.pageY;
      // if ((elemParent.hasClass('scene') || elemParent.hasClass('movie')) && elemParent.data('src') !== null && elemParent.data('src').length > 0) {
      //   // e.preventDefault();
      //   // var pointer = getPointerEvent(e);
      //   // currX = pointer.pageX;
      //   // currY = pointer.pageY;
      //   if (touchStarted) {
      //     // here you are swiping
      //     console.log('Swiping');
      //   }
      // }
    });
  }
  else {
    jQuery('.slider-wrapper').on('setPosition', function (slick, currentSlide) {
      var slides = jQuery(this).find('.slick-slide.slick-active');
        if (slides.length > 0) {
          slides.each(function () {


            if (jQuery(this).find('.preview').length >= 0 && jQuery('.hovered').length == 0) {
              jQuery(this).on("mouseenter", function(){
                // console.log(playerInited && playerInited)
                // playerInited && playerInited.destroy()
                if(playerInited){
                  playerInited.destroy()
                }
                setTimeout(()=>{
                  const isHover = e => e.parentElement.querySelector(':hover') === e;
                  if(isHover(this)){
                    console.log('now is hovered')
                    let leftPos = jQuery(this).offset().left + jQuery(this).outerWidth();
                let rightPos = jQuery(window).width() - (jQuery(this).offset().left + jQuery(this).outerWidth());
                let videoSrc = jQuery(this).find('.preview').data('vid');
                let imgSrc = jQuery(this).find('.preview').data('img');
                let path = jQuery(this).find('.preview').data('path');
                let more = jQuery(this).find('.preview').data('more');
                jQuery(this).find('.preview').parent().addClass('hovered');
                videoItem(videoSrc, imgSrc, path, jQuery(this).find('.preview'), more);

                if (leftPos >= 274) {
                  jQuery(this).find('.preview').attr('id', 'left');
                }

                if (leftPos >= 500) {
                  jQuery(this).find('.preview').attr('id', 'center');
                }

                if (leftPos >= 1800) {
                  jQuery(this).find('.preview').attr('id', 'right');
                }

                  }

                }, 500)


               let checkforPlayer =  setInterval(function () {
                let myplayer = false;
                  if(jQuery('.js-player').length > 0){
                    myplayer = true;
                    let player = new Plyr('.js-player', {
                      controls: [
                        'progress'
                      ],
                      loop: {
                        active: true
                      },
                      volume: 0,
                      muted: true
                    });
                    if (player) {
                      playerInited = player;
                      if(soundState){
                        player.muted = soundState;
                        player.volume = 0;
                      } else {
                        player.muted = soundState;
                        player.volume = 1;
                      }
                      player.play().catch(error => {
                          // Autoplay not allowed!
                          // Mute video and try to play again
                          player.play();
                          // Show something in the UI that the video is muted
                        });
                      //jQuery(this).prop('muted', false);
                    }
                    clearInterval(checkforPlayer);
                  }
                }, 1000);
              });


              jQuery(this).on("mouseleave", function () {
                // playerInited && playerInited.stop()
                // playerInited && playerInited.destroy()
                if(playerInited){
                  playerInited.stop()
                  playerInited.destroy()
                }
                jQuery(this).find('.preview').parent().removeClass('hovered');
                jQuery(this).find('.preview').attr('id', '');
                jQuery(this).find('.preview').empty();
              });
            }
          })
        }
    });

    console.log('desktop')
  }
});
